import { useState, useEffect } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Statistics from './components/Statistics'
import Team from './components/Team'
import FamilyBusiness from './components/FamilyBusiness'
import Services from './components/Discord'
import ApplicationForm from './components/ApplicationForm'
import HistoryPage from './components/HistoryPage'
import Footer from './components/Footer'
import SparklesBackground from './components/SparklesBackground'
import SnowBackground from './components/SnowBackground'
import AuthCallback from './pages/AuthCallback'
import Account from './pages/Account'
import Shop from './pages/Shop'
import { AuthProvider } from './auth/AuthContext'
import ScrollToTop from './components/ScrollToTop'

function App() {

  
  const [isApplicationOpen, setIsApplicationOpen] = useState(false)
  const [isHistoryOpen, setIsHistoryOpen] = useState(false)
  const [currentHash, setCurrentHash] = useState<string>(typeof window !== 'undefined' ? window.location.hash : '')

  // Scroll to top on page load
  useEffect(() => {
    // Force scroll to top immediately
    window.scrollTo(0, 0)
    
    // Also handle browser's scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    
    // Additional scroll to top after a short delay to ensure it works
    const timer = setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
    
    return () => clearTimeout(timer)
  }, [])

  // Track hash changes to switch views without full reload
  useEffect(() => {
    const onHashChange = () => setCurrentHash(window.location.hash)
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  const openApplication = () => {
    setIsApplicationOpen(true)
  }

  const closeApplication = () => {
    setIsApplicationOpen(false)
  }

  const openHistory = () => {
    setIsHistoryOpen(true)
  }

  const closeHistory = () => {
    setIsHistoryOpen(false)
  }

  const isCallback = typeof window !== 'undefined' && (
    window.location.pathname === '/auth/callback' || 
    window.location.pathname.includes('/auth/callback')
  )
  const isAccount = currentHash === '#account'
  const isShop = currentHash === '#shop'
  
  // Debug logging
  if (typeof window !== 'undefined') {

  }

  return (
    <AuthProvider>
      <div className="min-h-screen bg-dark-900 relative overflow-hidden">
        <SparklesBackground />
        <SnowBackground />
        {!isHistoryOpen && !isCallback && !isAccount && !isShop && (
          <Header onApplyClick={openApplication} />
        )}
        {isCallback ? (
          <AuthCallback />
        ) : isAccount ? (
          <Account onApplyClick={openApplication} />
        ) : isShop ? (
          <Shop onBack={() => window.location.hash = '#account'} />
        ) : (
          !isHistoryOpen && (
            <main>
              <Hero onApplyClick={openApplication} />
              <About onApplyClick={openApplication} onViewFullHistory={openHistory} />
              <Statistics />
              <Team onApplyClick={openApplication} />
              <FamilyBusiness onApplyClick={openApplication} />
              <Services onApplyClick={openApplication} />
            </main>
          )
        )}

        {!isHistoryOpen && !isCallback && !isShop && <Footer />}

        <ApplicationForm 
          isOpen={isApplicationOpen} 
          onClose={closeApplication} 
        />
        
        {isHistoryOpen && (
          <HistoryPage onBack={closeHistory} onApplyClick={openApplication} />
        )}
        
        <ScrollToTop />
      </div>
    </AuthProvider>
  )
}

export default App 